//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { PaymentSourceRegistrationNextAction } from './Enums';

export class ProcessPaymentSourceResultItem extends ItemBase {
    NextAction: PaymentSourceRegistrationNextAction = PaymentSourceRegistrationNextAction.None;
    AmountPaid: number | null = null;
    PaymentSourceID: string | null = null;
    ProcessorTransactionID: string | null = null;
    TransactionTime: string | null = null;
    StripeClientSecret: string | null = null;
    StripePaymentMethodType: string | null = null;
    ReturnURL: string | null = null;

    constructor(initializer?: Partial<ProcessPaymentSourceResultItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "ProcessPaymentSourceResultItem";
}
